import { Routes } from 'src/constants';
import { PageCategory } from 'src/lib/api';
import { RouteRecordRaw } from 'vue-router';

const getPageCategoryRoutes = () => {
	const pageCategoryRoutes = [];
	for (const category of Object.keys(PageCategory)) {
		pageCategoryRoutes.push({
			path: `${Routes.MENU}/${category}`,
			name: category,
			component: () => import('src/pages/ContentPageList.vue'),
		});
		pageCategoryRoutes.push({
			path: `${Routes.MENU}/${category}/:id`,
			meta: {
				title: category,
			},
			component: () => import('src/pages/ContentPage.vue'),
		});
	}
	return pageCategoryRoutes;
};

const routes: RouteRecordRaw[] = [
	{
		path: '/start',
		component: () => import('src/layouts/PlainLayout.vue'),
		children: [
			{
				path: Routes.START,
				name: Routes.START,
				component: () => import('src/pages/StartPage/StartPage.vue'),
			},
			{
				path: Routes.SPLASH,
				name: Routes.SPLASH,
				meta: { allowAnonymous: true },
				component: () => import('src/pages/SplashPage.vue'),
			},
		],
	},

	{
		path: '/auth',
		component: () => import('src/layouts/PlainLayout.vue'),
		meta: { allowAnonymous: true },
		children: [
			{
				path: 'login',
				name: Routes.LOG_IN,
				component: () => import('src/pages/LogInPage.vue'),
			},
			{
				path: Routes.RESET_PASSWORD,
				name: Routes.RESET_PASSWORD,
				component: () => import('src/pages/ResetPassword.vue'),
				meta: { allowAnonymous: true },
			},
			{
				path: Routes.PURCHASE_COURSE,
				name: Routes.PURCHASE_COURSE,
				component: () => import('src/pages/PurchaseCoursePage.vue'),
				meta: { allowAnonymous: true },
			},
		],
	},

	{
		path: '/',
		component: () => import('src/layouts/MainLayout.vue'),
		children: [
			{
				path: Routes.PROGRESS,
				name: Routes.PROGRESS,
				component: () => import('src/pages/ProgressPage.vue'),
			},
			{
				path: '',
				name: Routes.LOG,
				component: () => import('src/pages/LogPage.vue'),
			},
			{
				path: Routes.REVIEWS,
				name: Routes.REVIEWS,
				component: () => import('src/pages/ReviewsPage.vue'),
			},
			{
				path: Routes.MENU,
				name: Routes.MENU,
				component: () => import('src/pages/MenuPage/MenuPage.vue'),
			},

			{
				path: Routes.PROGRESS,
				name: Routes.PROGRESS,
				component: () => import('src/pages/ProgressPage.vue'),
			},
			{
				path: Routes.DIARY_WEEK_LOGS,
				name: Routes.DIARY_WEEK_LOGS,
				component: () => import('src/pages/DiaryWeekLogsPage.vue'),
			},
			{
				path: Routes.MEASUREMENT_WEEK_LOGS,
				name: Routes.MEASUREMENT_WEEK_LOGS,
				component: () => import('src/pages/MeasurementWeekLogsPage.vue'),
			},
			{
				path: Routes.NOTIFICATIONS,
				name: Routes.NOTIFICATIONS,
				component: () => import('src/pages/NotificationsPage.vue'),
			},
			{
				path: Routes.USER_INITIAL_INFO_OVERVIEW,
				name: Routes.USER_INITIAL_INFO_OVERVIEW,
				component: () =>
					import('src/pages/MenuPage/subpages/UserInitialInfoOverviewPage.vue'),
			},
			{
				path: Routes.USER_PROFILE,
				name: Routes.USER_PROFILE,
				component: () =>
					import('src/pages/MenuPage/subpages/UserProfilePage.vue'),
			},
			{
				path: Routes.DIARIES,
				name: Routes.DIARIES,
				component: () => import('src/pages/MenuPage/subpages/DiariesPage.vue'),
			},
			{
				path: Routes.MEASUREMENTS,
				name: Routes.MEASUREMENTS,
				component: () =>
					import('src/pages/MenuPage/subpages/MeasurementsPage.vue'),
			},
			...getPageCategoryRoutes(),
		],
	},

	// Always leave this as last one,
	// but you can also remove it
	{
		path: '/:catchAll(.*)*',
		name: Routes.NOT_FOUND,
		component: () => import('src/pages/404Page.vue'),
	},
];

export default routes;
